import React, { useState, useRef, useEffect } from 'react';
import '../styles/chatbot.css';

const FAQ_DATA = [
  {
    question: "🚀 How VastuZone Works",
    answer: "Welcome! Here is how it works: 1. Go to your Dashboard -> 2. Click 'Check New Vastu' to submit property details -> 3. Receive an initial assessment -> 4. Consult with our expert for personalized guidance."
  },
  {
    question: "How do I add a property?",
    answer: "Go to your Dashboard and select 'Check New Vastu' to submit your property layout and directions."
  },
  {
    question: "What is a Vastu Audit?",
    answer: "It is a practical evaluation of your property layout and directions to help create a balanced, functional environment."
  },
  {
    question: "Where are my reports?",
    answer: "Your reports are available in the 'My Reports' section, where you can review findings and download PDF reports."
  }
];

const SupportChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showCTA, setShowCTA] = useState(true);
  const [messages, setMessages] = useState([
    { type: 'bot', text: "Welcome to VastuZone. How can we help you today?" }
  ]);
  const chatEndRef = useRef(null);

  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (isOpen) {
      scrollToBottom();
    }
  }, [messages, isOpen]);

  useEffect(() => {
    const timer = setTimeout(() => setShowCTA(false), 12000);
    return () => clearTimeout(timer);
  }, []);

  const handleOptionClick = (qa) => {
    setMessages(prev => [...prev, { type: 'user', text: qa.question }]);
    
    setTimeout(() => {
      setMessages(prev => [...prev, { type: 'bot', text: qa.answer }]);
    }, 600);
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);
    setShowCTA(false);
  };

  return (
    <div className="chatbot-container">
      {showCTA && !isOpen && (
        <div className="chatbot-cta">
          How can I help you? 👋
        </div>
      )}

      {/* RESTORED BUTTON STYLE */}
      <button className="chatbot-trigger" onClick={toggleChat}>
        {isOpen ? (
          <>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            Close Help
          </>
        ) : (
          <>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            Ask for Help
          </>
        )}
      </button>

      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <h3>Help & Support</h3>
            <p>Frequently Asked Questions</p>
          </div>

          <div className="chatbot-content">
            {messages.map((msg, index) => (
              <div key={index} className={msg.type === 'bot' ? 'bot-msg' : 'user-msg'}>
                {msg.text}
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>

          <div className="chatbot-options">
            {FAQ_DATA.map((qa, index) => (
              <button 
                key={index} 
                className="option-btn"
                onClick={() => handleOptionClick(qa)}
                style={index === 0 ? { background: 'var(--ink)', color: 'var(--paper)' } : {}}
              >
                {qa.question}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SupportChatbot;
